// Angular
import {Component, Input, OnDestroy} from '@angular/core';
// RxJS
import {Subscription} from 'rxjs';
// Layout
import {SubheaderService} from '../../../../core/_base/layout';
import {MatDialog} from '@angular/material';
import {PoisPopup} from '../../../component/popup/pois/pois.popup';
import {MenuCategoryModel} from '../../../models/menu-category.model';
import {MenuItemModel} from '../../../models/menu-item.model';
import {Category, MenuSectionService} from '../../../../provider/menu-section.service';

@Component({
  selector: 'kt-subheader1',
  templateUrl: './subheader1.component.html',
  styleUrls: ['./subheader1.component.scss']
})
export class Subheader1Component implements OnDestroy {
  // Public properties
  @Input() fluid: boolean;
  @Input() clear: boolean;

  // Private properties
  private subscriptions: Subscription[] = [];

  constructor(public subheaderService: SubheaderService,
              public dialog: MatDialog,
              private menuSectionService: MenuSectionService) {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  openPoisDialog() {
    const menuSectionID = 121;
    const poisDialog = this.dialog.open(PoisPopup, {width: '1000px', height: '700px', data: menuSectionID});
    const sub = poisDialog.afterClosed().subscribe(result => {
      if (!(result == false || result == undefined)) {
        if (result.items.length > 0) {
          this.menuSectionService.addCategoryRet(result.title, menuSectionID).subscribe(
            (category: MenuCategoryModel) => {
              this.menuSectionService.setPoisItems(result.items, category.id, menuSectionID).subscribe(
                (items: MenuItemModel[]) => {
                  const newcCategory: Category = new Category(category, items);
                  this.subheaderService.poisDataChange$.next(newcCategory);
                },
                (err) => console.log(err)
              );
            },
            (err) => console.log(err)
          );
        } else {
          console.log('içinde bilgi bulunamadı');
        }
      }
    });
    this.subscriptions.push(sub);
  }
}
